import * as React from 'react';

import type { DialogActionsProps as MUIDialogActionsProps } from '@mui/material';
import { DialogActions as MUIDialogActions } from '@mui/material';

export interface DialogActionProps {
  /** 대화상자 작업 영역에 표시할 구성 요소다. */
  children?: React.ReactNode;
  /** 기본 여백 뒤에 합성할 추가 스타일이다. */
  sx?: MUIDialogActionsProps['sx'];
}

/**
 * 공용 Dialog Action 영역 레이아웃
 *
 * @param props 작업 영역 내용과 추가 스타일
 * @returns 공통 여백이 적용된 대화상자 작업 영역
 * @package
 */
export default function DialogActions({ children, sx }: DialogActionProps) {
  return (
    <MUIDialogActions
      sx={[
        {
          px: 4,
          pb: 3,
          pt: 0,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </MUIDialogActions>
  );
}
